import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { UserModule } from '@/store/modules/user'
  import useCourse from '@/composables/useCourse'
  import eventBus from '@/main'
  import AcademyProfileUpdateForm from '@/components/signup/AcademyProfileUpdateForm.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props) {

  const { smallLogo } = useIcons()
  const { setIsLoadingComponentViewData, logoUrl, is34ACompany } = useCommonMixin()
  const { fetchAllCourseModules, courseSectionsAssignedCourses } = useCourse()

  const loadingCompanyProfileQuestions = ref(true)

  const auth0Id = computed((): string | null => {
    return UserModule.auth0Id
  })

  const companyName = computed(() => UserModule.currentCompany?.name || 'KetchUp')

  const canSetUserProfile = computed(() => {
    if (auth0Id.value === null || !UserModule.email) return false
    return !UserModule.onboarded
  })

  watch(courseSectionsAssignedCourses, (value) => {
    if (value) {
      if (is34ACompany.value) {
        fetchAllCourseModules(value.map((c) => c.id) ?? [])
      }
      eventBus.$emit('turn-off-loader')
    }
  })

  if (courseSectionsAssignedCourses.value) {
    eventBus.$emit('turn-off-loader')
  } else {
    eventBus.$emit('turn-on-loader')
  }

  onMounted(async () => {
    setIsLoadingComponentViewData(false)

    if (UserModule.onboarded) {
      window.location.href = '/'
    }
  })

return { __sfc: true,smallLogo, setIsLoadingComponentViewData, logoUrl, is34ACompany, fetchAllCourseModules, courseSectionsAssignedCourses, loadingCompanyProfileQuestions, auth0Id, companyName, canSetUserProfile, computed, onMounted, ref, watch, LoadingSpinner, useIcons, useCommonMixin, UserModule, useCourse, eventBus, AcademyProfileUpdateForm }
}

})